import axios from "axios";
import {fadeIn, fadeOut} from '../general/functions';
import cart from "./cart";

export default class Order {
    constructor() {
        if (document.getElementById('pageOrder') !== null) {
            this.initLogin();
            this.initOrderType();
            this.initAccountExists();
            this.initShippingAddress();
            this.initPostalCode();
            this.initCountry();
            this.initPaymentMethod();
            this.initVat();

            this.update();
        }
    }

    initLogin() {
        if (document.getElementById('accountContainer') !== null) {
            const yesButtonContainer = document.getElementById('yesButtonContainer');
            const yesButton = document.getElementById('yesButton');
            const loginContainer = document.getElementById('loginContainer');
            const continueButton = loginContainer.querySelector('.continue a');

            yesButton.addEventListener('click', e => {
                e.preventDefault();
                fadeIn(loginContainer);
                fadeOut(yesButtonContainer, false);
            });

            continueButton.addEventListener('click', e => {
                e.preventDefault();
                fadeOut(loginContainer, false);
                fadeIn(yesButtonContainer, 'flex');
            });
        }
    }

    initOrderType() {
        const inputOrderType = document.querySelectorAll('input[name=order_type]');
        const inputCompanyName = document.getElementById('inputCompanyName');
        const inputVatNumber = document.getElementById('inputVatNumber');
        const forBusiness = document.getElementById('forBusiness');

        inputOrderType.forEach(radio => {
            radio.addEventListener('change', e => {
                if (radio.value === 'business') {
                    fadeIn(forBusiness);
                } else {
                    fadeOut(forBusiness);
                }
                this.update();
            });
        });

        [inputCompanyName, inputVatNumber].forEach(input => {
            input.addEventListener('blur', e => {
                this.update();
            });
        });
    }

    initAccountExists() {
        if (document.getElementById('inputEmail') !== null) {

            const inputEmail = document.getElementById('inputEmail');
            const emailMessage = document.querySelector('#inputEmail + small');
            const passwordContainer = document.getElementById('passwordContainer');

            let typingTimer;
            let doneTypingInterval = 1000;
            const CancelToken = axios.CancelToken;
            let source;
            if (source) {
                source.cancel();
            }
            clearTimeout(typingTimer);

            inputEmail.addEventListener('keyup', e => {

                if (source) {
                    source.cancel();
                }
                clearTimeout(typingTimer);
                if (!inputEmail.disabled) {
                    typingTimer = setTimeout(doneTyping, doneTypingInterval);
                }
            });

            function doneTyping() {
                source = CancelToken.source();

                axios({
                    method: 'post',
                    url: '/bestellen/bestaat-account',
                    data: {
                        email: inputEmail.value,
                    }
                })
                    .then(response => { // success
                        if (response.data) {
                            fadeIn(emailMessage);
                            fadeOut(passwordContainer);
                        } else {
                            fadeOut(emailMessage);
                            if (window.getComputedStyle(passwordContainer).display !== 'flex') {
                                fadeIn(passwordContainer, 'flex');
                            }
                        }
                    })
                    .catch(function (error) { // error

                    })
                    .then(function () { // always
                    });

            }

            if (inputEmail.value !== '') {
                const event = document.createEvent('HTMLEvents');
                event.initEvent('keyup', true, false);
                inputEmail.dispatchEvent(event);
            }
        }
    }

    initShippingAddress() {
        const shippingRadios = document.querySelectorAll('input[name=shipping]')
        const shippingAddress = document.getElementById('shippingAddress');
        const shippingCostsContainer = document.getElementById('shippingCostsContainer');

        shippingRadios.forEach(radio => {
            radio.addEventListener('change', e => {
                if (radio.value === 'shipping_address') {
                    fadeIn(shippingAddress);
                } else {
                    fadeOut(shippingAddress);
                }

                if (radio.value === 'pickup') {
                    fadeOut(shippingCostsContainer);
                } else {
                    if (window.getComputedStyle(shippingCostsContainer).display !== 'flex') {
                        fadeIn(shippingCostsContainer, 'flex');
                    }
                }

                this.update();
            });
        });
    }

    initPostalCode() {
        const addresses = document.querySelectorAll('.address-wrapper');

        addresses.forEach(address => {
            let postalCode = address.querySelector('.postal-code');
            let houseNumber = address.querySelector('.house-number');
            let street = address.querySelector('.street');
            let city = address.querySelector('.city');

            houseNumber.addEventListener('keyup', () => {
                if (houseNumber.value) {
                    houseNumber.value = houseNumber.value.replace(/[^\d]/g, '');
                }
            });

            [postalCode, houseNumber].forEach(item => {
                item.addEventListener('blur', e => {
                    if (postalCode.value !== '' && houseNumber.value !== '') {
                        axios({
                            method: 'post',
                            url: '/postcode',
                            data: {
                                postal_code: postalCode.value,
                                house_number: houseNumber.value
                            }
                        })
                            .then(response => { // success
                                let data = response.data;
                                if (data !== 'not found') {
                                    street.value = data.street;
                                    city.value = data.city;
                                    postalCode.value = data.postal_code;
                                } else {
                                    street.value = '';
                                    city.value = '';
                                }
                            });
                    }
                });
            });
        });
    }

    initCountry() {
        const inputBillingCountry = document.getElementById('inputBillingCountry');
        const inputShippingCountry = document.getElementById('inputShippingCountry');

        [inputBillingCountry, inputShippingCountry].forEach(select => {
            select.addEventListener('change', e => {
                this.update();
            });
        });
    }

    initPaymentMethod() {
        const paymentMethods = document.querySelectorAll('#paymentMethods input');
        let method;

        paymentMethods.forEach(paymentMethod => {
            paymentMethod.addEventListener('change', (e) => {
                this.update();
            });
        });
    }

    initVat() {
        const inputVatNumber = document.getElementById('inputVatNumber');
        const vatMessage = document.querySelector('#inputVatNumber + small');
        let typingTimer;
        let doneTypingInterval = 1000;
        const CancelToken = axios.CancelToken;
        let source;

        inputVatNumber.addEventListener('keyup', () => {
            if (source) {
                source.cancel();
            }
            clearTimeout(typingTimer);
            if (inputVatNumber.value) {
                inputVatNumber.value = inputVatNumber.value.replace(/[^\d\w]/g, '');
                typingTimer = setTimeout(doneTyping, doneTypingInterval);
            }
        });

        const that = this;

        function doneTyping() {
            source = CancelToken.source();

            axios({
                method: 'post',
                url: '/btw-valideren',
                data: {
                    'vat': inputVatNumber.value
                },
                cancelToken: source.token
            })
                .then(response => { // success
                    if (response.data) {
                        fadeOut(vatMessage);
                    } else {
                        fadeIn(vatMessage);
                    }
                    that.update();
                })
                .catch(function (error) { // error
                    console.log(error);
                })
                .then(function () { // always
                });
        }

        if (inputVatNumber.value !== '') {
            const event = document.createEvent('HTMLEvents');
            event.initEvent('keyup', true, false);
            inputVatNumber.dispatchEvent(event);
        }
    }

    update() {
        if (this.source) {
            this.source.cancel();
        }
        this.CancelToken = axios.CancelToken;
        this.source = this.CancelToken.source();

        const submitButton = document.getElementById('submitButton');
        submitButton.disabled = true;

        const inputOrderType = document.querySelector('input[name=order_type]:checked');
        const inputCompanyName = document.getElementById('inputCompanyName');
        const inputVatNumber = document.getElementById('inputVatNumber');
        const inputShipping = document.querySelector('input[name=shipping]:checked');
        const inputBillingCountry = document.getElementById('inputBillingCountry')
        const inputShippingCountry = document.getElementById('inputShippingCountry')
        const inputPaymentMethod = document.querySelector('input[name="payment_method"]:checked');

        axios({
            method: 'post',
            url: '/bestellen/update',
            data: {
                'order_type': inputOrderType.value,
                'company_name': inputCompanyName.value,
                'vat_number': inputVatNumber.value,
                'shipping': inputShipping.value,
                'billing_country': inputBillingCountry.value,
                'shipping_country': inputShippingCountry.value,
                'payment_method': inputPaymentMethod ? inputPaymentMethod.value : null
            },
            cancelToken: this.source.token
        })
            .then(response => { // success
                this.setValues(response.data);
                submitButton.disabled = false;
            })
            .catch(function (error) { // error
                console.log(error);
            })
            .then(function () { // always
            });
    }

    setValues(data) {
        const cartSubtotal = document.querySelector('.totals .cart-subtotal');
        const cartDiscount = document.querySelector('.totals .cart-discount');
        const shippingCosts = document.querySelector('.totals .shipping-costs');
        const cartTotal = document.querySelector('.totals .cart-total');
        const transactionCostsContainer = document.getElementById('transactionCostsContainer');
        const transactionCosts = document.querySelector('.transaction-costs');

        shippingCosts.innerText = data.shipping_costs;
        transactionCosts.innerText = data.transaction_costs;

        if (data.transaction_costs !== null && window.getComputedStyle(transactionCostsContainer).display !== 'flex') {
            fadeIn(transactionCostsContainer, 'flex');
        } else if (data.transaction_costs === null) {
            fadeOut(transactionCostsContainer);
        }

        cartSubtotal.innerText = data.subtotal;
        if (cartDiscount) {
            cartDiscount.innerText = data.discount;
        }
        cartTotal.innerText = data.total;

        this.setVatHtml(data);
        this.setCartRows(data.shift_vat);
    }

    setVatHtml(data) {
        const vatContainer = document.getElementById('vatContainer');
        const cartTotalTitle = document.querySelector('.cart-total-title');
        let vatHtml = '';

        if (data.shift_vat) {
            cartTotalTitle.innerText = cartTotalTitle.dataset.total;
            vatHtml = '<div class="row">\n' +
                '   <div class="col-12 text-right">BTW verlegd</div>\n' +
                '</div>';
        } else {
            cartTotalTitle.innerText = cartTotalTitle.dataset.totalIn;
            for (var key in data.vat) {
                if (data.vat.hasOwnProperty(key)) {
                    vatHtml += '<div class="row">\n' +
                        '   <div class="col-8">BTW ' + key + '%</div>\n' +
                        '   <div class="col-4 text-right">' + data.vat[key] + '</div>\n' +
                        '</div>';
                }
            }
        }

        vatContainer.innerHTML = vatHtml;
    }

    setCartRows(shiftVat) {
        const cartRows = document.querySelectorAll('#cartRows .cart-row');

        cartRows.forEach(row => {
            let cartSubtotal = row.querySelector('.cart-subtotal');
            if (shiftVat) {
                cartSubtotal.innerHTML = row.dataset.totalExVat;
            } else {
                cartSubtotal.innerHTML = row.dataset.total;
            }
        });
    }
}
